import { render, staticRenderFns } from "./MainCategoryComponent.vue?vue&type=template&id=98d4770a"
import script from "./MainCategoryComponent.vue?vue&type=script&lang=js"
export * from "./MainCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryComponent.vue?vue&type=style&index=0&id=98d4770a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports